import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { LoginPage } from '../auth/login-page';
import { safeNextPath } from '../lib/session/next-path';

/**
 * `/login?next=<path>` (M2.8, FR-SUPER-01).
 *
 * `?next=` is validated twice - once here by `validateSearch`, and again by
 * `safeNextPath` before the navigation. The duplication is deliberate: this is the
 * screen that creates a session for the console that administers every tenant, which
 * makes it the most valuable place in the platform for an open redirect.
 */
export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): { next?: string } => {
    const next = safeNextPath(search['next'], '');
    return next === '' ? {} : { next };
  },
  component: LoginRoute,
});

function LoginRoute() {
  const navigate = useNavigate();
  const { next } = Route.useSearch();

  return (
    <LoginPage
      onSignedIn={() => {
        void navigate({ to: safeNextPath(next), replace: true });
      }}
    />
  );
}
